import { render, staticRenderFns } from "./OrdersEditModal.vue?vue&type=template&id=3ef254c7&scoped=true&"
import script from "./OrdersEditModal.vue?vue&type=script&lang=js&"
export * from "./OrdersEditModal.vue?vue&type=script&lang=js&"
import style0 from "./OrdersEditModal.vue?vue&type=style&index=0&id=3ef254c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef254c7",
  null
  
)

export default component.exports